module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Bold.a7a2b14b.woff2";